import fetch from "../../fetch";
import { rapydPayPath, headers } from "./constants";

export async function sendRapydPayment(
  amount,
  currency,
  full_name,
  reservationId
) {
  try {
    const response = await fetch(rapydPayPath, {
      method: "POST",
      headers,
      body: JSON.stringify({ amount, currency, full_name, reservationId }),
      credentials: "include",
    });

    const jsonData = await response.json();

    const redirect = jsonData?.data?.body?.data?.redirect_url || "";

    if (jsonData?.status == 200 && redirect) {
      window.localStorage.setItem('pendingReservationId', reservationId);
      window.location.href = redirect;

      return {
        status: 200,
        errorMessage: null,
        paymentUrl: redirect
      };
    } else {
      return {
        status: 400,
        errorMessage: jsonData?.errorMessage || "Failed to initiate payment"
      };
    }
  } catch (error) {
    console.error('Error initiating payment:', error);
    return {
      status: 500,
      errorMessage: "Network error while initiating payment"
    };
  }
}

export async function getRapydPaymentResult(reservationId) {
  try {
    const response = await fetch("/rapyd-booking-complete", {
      method: "POST",
      headers,
      body: JSON.stringify({ reservationId }),
      credentials: "include",
    });

    const res = await response.json();

    if (res?.status === 200) {
      return {
        status: 200,
        errorMessage: null,
        reservationState: res.reservationState || 'pending'
      };
    } else {
      return {
        status: 400,
        errorMessage: res?.errorMessage || "Error checking payment status",
      };
    }
  } catch (error) {
    console.error("Error checking payment status:", error);
    return {
      status: 500,
      errorMessage: "Network error while checking payment status",
    };
  }
}
